(function () {
  'use strict';

  var routes = window.themeRoutes || { cartUrl: '/cart', cartAddUrl: '/cart/add', cartChangeUrl: '/cart/change', root: '/' };

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || window.themeMoney || '{{amount}} €';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function showToast(ctx, message) {
    var toast = $('[data-toast]', ctx) || $('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.hidden = true; }, 3800);
  }

  function lockScroll(lock) { document.body.classList.toggle('no-scroll', lock); }

  /* ---------- Menu drawer ---------- */
  function initMenu() {
    var drawer = $('[data-menu-drawer]');
    var overlay = $('[data-menu-overlay]');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); overlay.hidden = false; lockScroll(true); }
    function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); overlay.hidden = true; lockScroll(false); }
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Scroll to top ---------- */
  function initScrollTop() {
    var btn = $('[data-scroll-top]');
    if (!btn) return;
    function update() { btn.classList.toggle('is-visible', window.scrollY > 600); }
    window.addEventListener('scroll', update, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    update();
  }

  /* ---------- Generic scroll-snap slider ---------- */
  function buildDots(container, count, onClick) {
    if (!container) return [];
    container.innerHTML = '';
    var dots = [];
    for (var i = 0; i < count; i++) {
      (function (index) {
        var b = el('button', { type: 'button', 'aria-label': 'Ir a ' + (index + 1) });
        b.addEventListener('click', function () { onClick(index); });
        container.appendChild(b);
        dots.push(b);
      })(i);
    }
    return dots;
  }

  function nearestIndex(track, slides) {
    var left = track.scrollLeft;
    var best = 0, bestDist = Infinity;
    slides.forEach(function (s, i) {
      var d = Math.abs(s.offsetLeft - track.firstElementChild.offsetLeft - left);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function initSliders(root) {
    $$('[data-slider]', root).forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      var slides = $$('[data-slider-slide]', slider);
      if (!track || !slides.length) return;
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }
      var dots = buildDots($('[data-slider-dots]', slider), slides.length, goTo);
      var prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
      function update() {
        var idx = nearestIndex(track, slides);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        if (prev) prev.disabled = idx === 0;
        if (next) next.disabled = idx === slides.length - 1;
        return idx;
      }
      if (prev) prev.addEventListener('click', function () { goTo(update() - 1); });
      if (next) next.addEventListener('click', function () { goTo(update() + 1); });
      var raf;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var gallery = $('[data-gallery]', root);
    if (!gallery) return null;
    var track = $('[data-gallery-track]', gallery);
    var slides = $$('[data-gallery-slide]', gallery);
    var thumbs = $$('[data-thumb-index]', gallery);
    var thumbList = $('[data-gallery-thumbs]', gallery);
    if (!slides.length) return null;

    function goTo(i, smooth) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    var dots = buildDots($('[data-gallery-dots]', gallery), slides.length, function (i) { goTo(i); });
    var current = 0;
    function setActive(i) {
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && thumbList) {
        var li = t.parentElement;
        var target = li.offsetLeft - thumbList.clientWidth / 2 + li.clientWidth / 2;
        thumbList.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = nearestIndex(track, slides);
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb-index'), 10)); });
    });
    var tp = $('[data-thumbs-prev]', gallery), tn = $('[data-thumbs-next]', gallery);
    if (tp) tp.addEventListener('click', function () { goTo(current - 1); });
    if (tn) tn.addEventListener('click', function () { goTo(current + 1); });
    setActive(0);

    return {
      goToImage: function (src) {
        if (!src) return;
        var key = src.split('?')[0].split('/').pop().replace(/_\d+x\d*|_\d*x\d+/, '');
        for (var i = 0; i < slides.length; i++) {
          var img = $('img', slides[i]);
          if (img && img.src.split('?')[0].split('/').pop().replace(/_\d+x\d*|_\d*x\d+/, '') === key) { goTo(i); return; }
        }
        var firstImage = $('img', slides[0]);
        if (firstImage) { firstImage.removeAttribute('srcset'); firstImage.src = src; goTo(0); }
      }
    };
  }

  /* ---------- Mini reviews (fade slider) ---------- */
  function initMiniReviews(root) {
    $$('[data-mini-slider]', root).forEach(function (wrap) {
      var slides = $$('[data-mini-slide]', wrap);
      if (!slides.length) return;
      var current = 0, timer;
      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === current); });
      }
      var dots = slides.length > 1 ? buildDots($('[data-mini-dots]', wrap), slides.length, function (i) { show(i); restart(); }) : [];
      function restart() {
        clearInterval(timer);
        if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { show(current + 1); }, 9000);
      }
      show(0);
      restart();
    });
  }

  /* ---------- Delivery dates ---------- */
  function initDates(root) {
    var lang = (document.documentElement.lang || 'es').slice(0, 2);
    var fmt;
    try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' }); }
    catch (e) { fmt = new Intl.DateTimeFormat('es', { day: 'numeric', month: 'short' }); }
    $$('[data-date-range]', root).forEach(function (node) {
      var min = parseInt(node.getAttribute('data-min'), 10) || 0;
      var max = parseInt(node.getAttribute('data-max'), 10) || min;
      var a = new Date(), b = new Date();
      a.setDate(a.getDate() + min);
      b.setDate(b.getDate() + max);
      node.textContent = fmt.format(a) + ' – ' + fmt.format(b);
    });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null,
    init: function () {
      this.drawer = $('[data-cart-drawer]');
      if (!this.drawer) return;
      var self = this;
      this.overlay = $('[data-cart-overlay]');
      $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      if (window.themeCartDrawer !== false && !/\/cart\/?$/.test(location.pathname)) {
        $$('[data-cart-open]').forEach(function (a) {
          a.addEventListener('click', function (e) { e.preventDefault(); self.open(); });
        });
      }
    },
    open: function () {
      if (!this.drawer) { location.href = routes.cartUrl; return; }
      this.refresh();
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay.hidden = false;
      lockScroll(true);
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay.hidden = true;
      lockScroll(false);
    },
    refresh: function () {
      var self = this;
      return fetch(routes.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    change: function (line, quantity) {
      var self = this;
      return fetch(routes.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); });
    },
    render: function (cart) {
      var self = this;
      $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      if (!this.drawer) return;
      var list = $('[data-cart-items]', this.drawer);
      var empty = $('[data-cart-empty]', this.drawer);
      var footer = $('[data-cart-footer]', this.drawer);
      list.innerHTML = '';
      empty.hidden = cart.item_count > 0;
      footer.hidden = cart.item_count === 0;
      list.hidden = cart.item_count === 0;
      cart.items.forEach(function (item, index) {
        var line = index + 1;
        var img = item.image ? el('img', { class: 'cart-item__image', src: item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'), alt: '', width: '80', height: '80' }) : el('div', { class: 'cart-item__image' });
        var minus = el('button', { type: 'button', 'aria-label': 'Quitar uno' });
        minus.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>';
        var plus = el('button', { type: 'button', 'aria-label': 'Añadir uno' });
        plus.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>';
        minus.addEventListener('click', function () { self.change(line, item.quantity - 1); });
        plus.addEventListener('click', function () { self.change(line, item.quantity + 1); });
        var remove = el('button', { type: 'button', class: 'cart-item__remove', text: 'Eliminar' });
        remove.addEventListener('click', function () { self.change(line, 0); });
        var info = el('div', null, [
          el('a', { class: 'cart-item__title', href: item.url, text: item.product_title }),
          item.variant_title ? el('div', { class: 'cart-item__variant', text: item.variant_title }) : null,
          el('div', { class: 'cart-item__qty' }, [minus, el('span', { text: String(item.quantity) }), plus]),
          remove
        ]);
        info.querySelector('.cart-item__title').style.textDecoration = 'none';
        list.appendChild(el('div', { class: 'cart-item' }, [img, info, el('div', { class: 'cart-item__price', text: formatMoney(item.final_line_price) })]));
      });
      var subtotal = $('[data-cart-subtotal]', this.drawer);
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    }
  };

  /* ---------- Main product: bundles, variants, add to cart ---------- */
  function initProduct(section) {
    var data, swatches = {};
    function parseLoose(node) { return JSON.parse(node.textContent.replace(/,\s*([}\]])/g, '$1')); }
    try { data = parseLoose($('[data-product-json]', section)); } catch (e) { console.error('Product JSON', e); return; }
    try { swatches = parseLoose($('[data-swatches]', section)); } catch (e) { swatches = {}; }

    var gallery = initGallery(section);
    var isDemo = !!data.demo;
    var adapter = data.adapter;
    var adapterSelections = [false,false,false];
    var variants = data.variants || [];
    var colourPhotos={"Blanco":"https://cdn.shopify.com/s/files/1/1110/7267/4130/files/Captura_de_pantalla_2026-09-15_a_las_20.46.57_ec2f9401-7395-4aae-83a6-2a829ef36553_800x800.png?v=1789498070","Negro":"https://cdn.shopify.com/s/files/1/1110/7267/4130/files/Captura_de_pantalla_2026-09-15_a_las_20.47.12_800x800.png?v=1789498056"};
    variants.forEach(function(v){if(colourPhotos[v.options[0]])v.image=colourPhotos[v.options[0]];});
    var options = data.options || [];
    var hasRealOptions = !(options.length === 1 && variants.length === 1 && /default/i.test(variants[0].options[0] || ''));
    var firstAvailable = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var selections = [firstAvailable, firstAvailable, firstAvailable];
    var bundles = $$('[data-bundle]', section);
    var qty = 1;

    var optionValues = options.map(function (_, i) {
      var seen = [];
      variants.forEach(function (v) { if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]); });
      return seen;
    });

    function findVariant(opts, changedIndex) {
      var exact = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
      if (exact) return exact;
      return variants.filter(function (v) { return v.options[changedIndex] === opts[changedIndex] && v.available; })[0]
        || variants.filter(function (v) { return v.options[changedIndex] === opts[changedIndex]; })[0];
    }

    function swatchColor(value) {
      if (swatches[value]) return swatches[value];
      var lower = String(value).toLowerCase();
      for (var k in swatches) { if (k.toLowerCase() === lower) return swatches[k]; }
      return null;
    }

    function renderRows(bundle) {
      var container = $('[data-variant-rows]', bundle);
      var label = $('[data-options-label]', bundle);
      if (!container) return;
      container.innerHTML = '';
      if (label) {
        label.textContent = hasRealOptions ? options.join(', ') : '';
        label.hidden = !hasRealOptions;
      }
      if (!hasRealOptions) return;
      for (var r = 0; r < qty; r++) {
        (function (row) {
          var variant = selections[row];
          var rowEl = el('div', { class: 'variant-row' });
          if (qty > 1) rowEl.appendChild(el('span', { class: 'variant-row__index', text: '#' + (row + 1) }));
          var thumb = el('img', { class: 'variant-row__thumb', alt: '', width: '54', height: '70' });
          if (variant.image) thumb.src = variant.image; else thumb.hidden = true;
          rowEl.appendChild(thumb);
          options.forEach(function (optName, oi) {
            var select = el('select', { 'aria-label': optName + (qty > 1 ? ' #' + (row + 1) : '') });
            optionValues[oi].forEach(function (val) {
              var o = el('option', { value: val, text: val });
              if (val === variant.options[oi]) o.selected = true;
              select.appendChild(o);
            });
            var wrap = el('div', { class: 'select' });
            var dot = null;
            var color = swatchColor(variant.options[oi]);
            var anyColor = optionValues[oi].some(function (v) { return !!swatchColor(v); });
            if (anyColor) {
              wrap.classList.add('select--swatch');
              dot = el('span', { class: 'select__swatch' });
              dot.style.background = color || 'transparent';
              wrap.appendChild(dot);
            }
            wrap.appendChild(select);
            select.addEventListener('change', function () {
              var opts = selections[row].options.slice();
              opts[oi] = select.value;
              var found = findVariant(opts, oi);
              if (found) {
                selections[row] = found;
                if (found.options[1] !== '3,5 mm') adapterSelections[row] = false;
                if (oi === 0 && gallery && found.image) gallery.goToImage(found.image);
              }
              renderRows(bundle);
              updatePrices();
              syncForm();
            });
            rowEl.appendChild(wrap);
          });
          if (adapter) {
            var addon = el('label', {class:'hp-adapter-row'});
            var cb = el('input', {type:'checkbox','data-addon':'','data-addon-variant':String(adapter.id),'aria-label':'Añadir adaptador Lightning al teléfono '+(row+1)});
            cb.checked = adapterSelections[row];
            cb.disabled = !isDemo && !adapter.available;
            addon.appendChild(cb);
            addon.appendChild(el('img',{src:adapter.image,alt:'Adaptador Lightning a 3,5 mm',width:'42',height:'42'}));
            var caption=el('span',{text:'Añadir adaptador para iPhone con Lightning'});
            caption.appendChild(el('small',{text:(!isDemo && !adapter.available)?'No disponible':'Con auricular de 3,5 mm · admite llamadas'}));
            addon.appendChild(caption);
            addon.appendChild(el('strong',{text:'+ '+formatMoney(adapter.price)}));
            cb.addEventListener('change',function(){
              adapterSelections[row]=cb.checked;
              if(cb.checked){var found=findVariant([selections[row].options[0],'3,5 mm'],1);if(found){selections[row]=found;}}
              renderRows(bundle);updatePrices();syncForm();
            });
            rowEl.appendChild(addon);
          }
          container.appendChild(rowEl);
        })(r);
      }
    }

    function updatePrices() {
      bundles.forEach(function (bundle) {
        var q = parseInt(bundle.getAttribute('data-qty'), 10);
        var discount = parseFloat(bundle.getAttribute('data-discount')) || 0;
        var sum = 0;
        for (var i = 0; i < q; i++) {
          var v = bundle.classList.contains('is-selected') ? selections[i] : selections[0];
          sum += v.price;
        }
        var total = parseInt(bundle.getAttribute('data-fixed-total'),10) || Math.round(sum * (100 - discount) / 100);
        var priceEl = $('[data-bundle-price]', bundle);
        var compareEl = $('[data-bundle-compare]', bundle);
        var subEl = $('[data-bundle-subtitle]', bundle);
        if (priceEl) priceEl.textContent = formatMoney(total);
        if (compareEl) compareEl.textContent = formatMoney(sum);
        if (bundle.classList.contains('is-selected')) {
          var extras=adapterSelections.slice(0,qty).filter(Boolean).length*(adapter?adapter.price:0);
          var grand=$('[data-grand-total]',section);
          if(grand){grand.textContent='Total: '+formatMoney(total+extras);}
        }
        if (subEl) {
          var tpl = subEl.getAttribute('data-template') || '';
          subEl.textContent = tpl.replace('[unit]', formatMoney(Math.round(total / q))).replace('[discount]', discount);
        }
      });
    }

    var form = $('[data-product-form]', section);
    var atc = $('[data-atc]', section);
    var errorBox = $('[data-form-error]', section);

    function syncForm() {
      if (!form) return;
      var idInput = $('[data-variant-input]', form);
      var qtyInput = $('[data-quantity-input]', form);
      if (idInput) idInput.value = selections[0].id;
      if (qtyInput) qtyInput.value = qty;
      var allAvailable = true;
      for (var i = 0; i < qty; i++) if (!selections[i].available || (adapterSelections[i] && (!adapter || !adapter.available))) allAvailable = false;
      if (atc) {
        atc.disabled = !allAvailable;
        var label = $('[data-atc-label]', atc);
        if (label) {
          if (!label.getAttribute('data-default')) label.setAttribute('data-default', label.textContent);
          label.textContent = allAvailable ? label.getAttribute('data-default') : 'Agotado';
        }
      }
    }

    function selectBundle(bundle) {
      bundles.forEach(function (b) {
        var active = b === bundle;
        b.classList.toggle('is-selected', active);
        var radio = $('input[type="radio"]', b);
        if (radio) radio.checked = active;
        if (!active) { var rows = $('[data-variant-rows]', b); if (rows) rows.innerHTML = ''; }
      });
      qty = parseInt(bundle.getAttribute('data-qty'), 10) || 1;
      for (var i = 1; i < 3; i++) if (!bundle._touched) selections[i] = selections[i] || selections[0];
      renderRows(bundle);
      updatePrices();
      syncForm();
    }

    bundles.forEach(function (bundle) {
      var header = $('.bundle__header', bundle);
      var radio = $('input[type="radio"]', bundle);
      if (radio) radio.addEventListener('change', function () { selectBundle(bundle); });
      header.addEventListener('click', function (e) {
        e.preventDefault();
        if (!bundle.classList.contains('is-selected')) selectBundle(bundle);
      });
    });

    function addToCart(e) {
      if (e) e.preventDefault();
      if (isDemo) {
        showToast(section, 'Modo demostración: elige tu producto en Personalizar tema → Producto principal.');
        return;
      }
      var selected = bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0];
      var counts = {};
      for (var i = 0; i < qty; i++) counts[selections[i].id] = (counts[selections[i].id] || 0) + 1;

      if (selected) {
        $$('[data-addon]:checked', selected).forEach(function (cb) {
          var vid = parseInt(cb.getAttribute('data-addon-variant'), 10);
          if (vid) counts[vid]=(counts[vid]||0)+1;
        });
      }
      var items = Object.keys(counts).map(function(id){return {id:parseInt(id,10),quantity:counts[id]};});
      if (errorBox) errorBox.hidden = true;
      if (atc) { atc.disabled = true; atc.setAttribute('aria-busy', 'true'); }
      fetch(routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'No se pudo añadir al carrito');
          if (window.themeCartDrawer === false || !Cart.drawer) { location.href = routes.cartUrl; return; }
          Cart.open();
        })
        .catch(function (err) {
          if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
        })
        .finally(function () {
          if (atc) atc.removeAttribute('aria-busy');
          syncForm();
        });
    }

    if (form) form.addEventListener('submit', addToCart);
    $$('[data-demo-atc]', section).forEach(function (b) { b.addEventListener('click', addToCart); });

    var initial = bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0] || bundles[0];
    if (initial) selectBundle(initial);
  }

  /* ---------- Boot ---------- */
  function boot(root) {
    $$('[data-gallery]', root).forEach(function (g) { if (!g.closest('[data-product-section]')) initGallery(g.parentElement); });
    initSliders(root);
    initMiniReviews(root);
    initDates(root);
    $$('[data-product-section]', root).forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initScrollTop();
    Cart.init();
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
